import { SVGProps } from 'react'

const RsrIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      d="M12.5518 1C14.6091 1.00001 16.3338 1.48723 17.5156 2.65527C18.703 3.82029 19.1992 5.52525 19.1992 7.55664C19.1992 9.14362 18.8194 10.5302 17.9658 11.6221L17.9629 11.626C17.3825 12.3609 16.65 12.9245 15.7891 13.3291L19.3252 19.5029L20.1816 21H14.0518L13.7676 20.4805L10.2656 14.0869H9.66113V21H4.22559V14.0928H1V5.5127H4.22559V1H12.5518ZM9.66211 9.25684H13.0039C13.3586 9.25678 13.4502 9.1625 13.4717 9.13867C13.5115 9.09425 13.6182 8.92836 13.6182 8.45996V6.61328C13.6182 6.37319 13.5943 6.20975 13.5654 6.10645C13.5371 6.00525 13.5123 5.98789 13.5264 6.00293L13.5186 5.99512C13.5108 5.99095 13.4944 5.98212 13.4648 5.97266C13.3834 5.94659 13.2375 5.91995 13.0039 5.91992H9.66211V9.25684Z"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
)

export default RsrIcon
